import { render, staticRenderFns } from "./columns-info.vue?vue&type=template&id=f5b63668&scoped=true"
import script from "./columns-info.vue?vue&type=script&lang=js"
export * from "./columns-info.vue?vue&type=script&lang=js"
import style0 from "./columns-info.vue?vue&type=style&index=0&id=f5b63668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b63668",
  null
  
)

export default component.exports